import { BaseEntity } from ".";
import { IGet_characters_character_id_loyalty_points_200_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedCorporationEntity } from "./CorporationEntityCache";

export class CharacterLPEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Character Loyalty Points";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_characters_character_id_loyalty_points_200_ok[]> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      if (props) {
        const characterEntity = await getCachedCharacterEntity(id);
        if (characterEntity != null) {
          entity.properties["owner"] = await characterEntity.toJson();
          entity.text = `Loyalty points for ${characterEntity?.props.name.toString()}`;
        }
        let data_array: Excel.CellValue[][] = [];
        const numberOptions = { minimumFractionDigits: 0 };
        for (const y of props) {
          if (y) {
            const corpEntity = await getCachedCorporationEntity(y.corporation_id);
            if (corpEntity !== null) {
              data_array.push([
                {
                  type: Excel.CellValueType.entity,
                  text:
                    corpEntity?.props.name.toString() + ": " + y.loyalty_points.toLocaleString("en-GB", numberOptions),
                  properties: {
                    corporation: await corpEntity.toJson(),
                    loyalty_points: {
                      type: Excel.CellValueType.double,
                      basicValue: y.loyalty_points,
                    },
                  },
                },
              ]);
            } else {
              data_array.push([
                {
                  type: Excel.CellValueType.entity,
                  text: y.corporation_id + ": " + y.loyalty_points.toLocaleString("en-GB", numberOptions),
                  properties: {
                    corporation: {
                      type: Excel.CellValueType.double,
                      basicValue: y.corporation_id,
                    },
                    loyalty_points: {
                      type: Excel.CellValueType.double,
                      basicValue: y.loyalty_points,
                    },
                  },
                },
              ]);
            }
          }
        }
        if (data_array.length) {
          entity.properties["loyalty_points"] = {
            type: Excel.CellValueType.array,
            elements: data_array,
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
